import DealInvestorProfileList from '../../../components/ui/dealInvestorProfileList';

function InvestorLastInvestments(props) {
  return <DealInvestorProfileList {...props} surfaceKey="appInvestorProfile" />;
}

export default InvestorLastInvestments;
